import { i18n } from 'reactifi/src/i18n';
export default i18n;
